export default __webpack_public_path__ + "static/media/Deloitte_new_logo.46ffb6ff.png";